<template>
  <div class="page person-query-page flex-col">
    <AppHeader />
    <!-- <van-nav-bar title="人员查询" left-arrow @click-left="$router.back()" :border="false" class="custom-nav" /> -->
    <div class="content flex-col">
      <van-field v-model="form.userName" label="姓名" placeholder="请输入姓名" clearable class="custom-field" />
      <van-field v-model="form.userGliet" label="证书编号" placeholder="请输入证书编号" clearable class="custom-field" />
      <van-button type="primary" block round class="query-btn" @click="handleQuery" :loading="loading">查询</van-button>

      <!-- 工作证结果 -->
      <div class="card-wrapper" v-if="result">
        <div class="work-card">
           <img class="work-card-img" :src="result.img"/>
        </div>
      </div>
      <!-- toast 提示 -->
      <transition name="toast-fade">
        <div class="toast-wrap" v-if="showToast">{{ toastMessage }}</div>
      </transition>
    </div>
    <BackTop />
    <CopyrightFooter />
  </div>
   
</template>

<script>
import { NavBar, Field, Button } from 'vant'
import { getPersonCre } from '../api/api'
import AppHeader from './components/AppHeader.vue'
import CopyrightFooter from './components/CopyrightFooter.vue'
import BackTop from './components/BackTop.vue'

export default {
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    AppHeader,
    CopyrightFooter,
    BackTop
  },
  data() {
    return {
      form: { userName: '', userGliet: '' },
      result: null,
      showToast: false,
      toastMessage: '',
      loading: false,
    }
  },
  mounted() { 
    this.setTitle()
    this.fetchParams()
  },
  methods: {
    setTitle(){
      let title = "人员查询"
      if(window.__appBasic){
        title += ' - ' + window.__appBasic.appName
      }else{
        title += ' - 生态保护与法治报道中心'
      }
      document.title = title
    },
    fetchParams() {
      const query = this.getHashQuery(); 
      if(query){
        this.form.userName = query.userName;
        this.form.userGliet =  query.userGliet; 
        this.handleQuery();
      } 
    },
    getHashQuery() {
        let hash = window.location.hash;
        if (!hash || !hash.includes('?')) return null;
        let qs = hash.split('?')[1];
        let obj = {};
        qs.split('&').forEach(seg=>{
            let arr = seg.split('=');
            let k = arr[0];
            let v = arr.length>1 ? decodeURIComponent(arr[1]) : '';
            if(k){
                obj[k] = v;
            }
        });
        return obj;
    },
    showMsg(msg) {
      this.toastMessage = msg
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, 2500)
    },
    async handleQuery() {
      if (!this.form.userName || !this.form.userGliet) {
        this.$toast('请输入姓名和证书编号')
        return
      }
      this.loading = true
      try {
        const data = await getPersonCre(this.form)
        // 如果接口返回的是对象则直接用，否则用 mock 数据结构
        if (data && typeof data === 'object') {
          this.result = data
          console.log("result --> ", data)
          let img =  this.result.userCre ? JSON.parse(this.result.userCre)[0].url : ''
          this.result.img = img
        } else {
          this.showMsg(`查询不到姓名为"${this.form.userName}"，证书编号为"${this.form.userGliet}"的证书，此人已不是我单位工作人员。`)
        } 
      } catch (e) {
        this.showMsg('查询失败，请联系管理员')
      } finally {
        this.loading = false
      }
    },
    mockResult() {
      return {}
    },
  },
}
</script>

<style scoped lang="scss">
.person-query-page {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.custom-nav {
  background-color: #0464CA;
  ::v-deep .van-nav-bar__title { color: #fff; font-weight: 600; }
  ::v-deep .van-nav-bar__arrow { color: #fff; }
}
.content {
  padding: 16px;
  gap: 12px;
}
.custom-field {
  border-radius: 8px;
  background: #fff;
}
.query-btn {
  margin-top: 8px;
  background-color: #0464CA;
  border-color: #0464CA;
  font-weight: 600;
}

.card-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
.work-card {
  position: relative;
  width: 100%;
  max-width: 343px;
  background: linear-gradient(135deg, #f0f6fc 0%, #e8f1fa 100%);
  border: 1px solid rgba(4, 100, 202, 0.15);
  border-radius: 12px;
  padding: 20px 16px 16px;
  box-shadow: 0 8px 24px rgba(4, 100, 202, 0.12);
  overflow: hidden;
  .work-card-img{
    width: 100%;
  }
}
.card-pattern {
  position: absolute;
  inset: 0;
  opacity: 0.06;
  background-image:
    repeating-linear-gradient(45deg, transparent, transparent 10px, #0464CA 10px, #0464CA 11px),
    repeating-linear-gradient(-45deg, transparent, transparent 10px, #0464CA 10px, #0464CA 11px);
  pointer-events: none;
}
.card-header {
  position: relative;
  z-index: 1;
  margin-bottom: 16px;
}
.badge-shield {
  width: 44px;
  height: 52px;
  background: linear-gradient(180deg, #0464CA 0%, #033a7a 100%);
  clip-path: polygon(50% 0%, 100% 10%, 100% 65%, 50% 100%, 0% 65%, 0% 10%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.badge-star {
  color: #fff;
  font-size: 16px;
  margin-top: -2px;
}
.card-titles {
  .card-org {
    font-size: 16px;
    font-weight: 600;
    color: #0464CA;
    letter-spacing: 1px;
  }
  .card-type {
    font-size: 22px;
    font-weight: 600;
    color: #0464CA;
    letter-spacing: 8px;
    margin-top: 2px;
  }
}
.card-body {
  position: relative;
  z-index: 1;
  gap: 12px;
  margin-bottom: 10px;
}
.photo-box {
  width: 100px;
  height: 130px;
  background: #fff;
  border: 1px solid rgba(4, 100, 202, 0.2);
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}
.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.photo-placeholder {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  .photo-icon { font-size: 28px; color: #ccc; }
  .photo-text { font-size: 11px; color: #999; margin-top: 2px; }
}
.info-area {
  flex: 1;
  gap: 8px;
  padding-top: 2px;
}
.info-row {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  color: #222;
}
.info-label {
  width: 40px;
  flex-shrink: 0;
  font-weight: 600;
  color: #333;
}
.info-value {
  font-weight: 500;
  color: #111;
}
.info-list {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  .info-row.full {
    .info-label { width: 48px; }
  }
}
.card-seal {
  position: absolute;
  right: 20px;
  bottom: 40px;
  z-index: 2;
  opacity: 0.8;
}
.seal-ring {
  width: 82px;
  height: 82px;
  border: 2.5px solid #c9302c;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.seal-text-top {
  position: absolute;
  top: 8px;
  font-size: 9px;
  color: #c9302c;
  font-weight: 600;
  width: 76px;
  text-align: center;
  line-height: 1.2;
}
.seal-star {
  font-size: 22px;
  color: #c9302c;
  line-height: 1;
}
.seal-text-bottom {
  position: absolute;
  bottom: 8px;
  font-size: 10px;
  color: #c9302c;
  font-weight: 600;
}


/* toast 提示 */
.toast-wrap {
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  padding: 12px 28px;
  background: #fff3e0;
  color: #e6a23c;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  border: 1px solid #ffd591;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}
.toast-fade-enter-active {
  animation: toast-pop 0.4s ease;
}
.toast-fade-leave-active {
  animation: toast-pop 0.25s ease reverse;
}
@keyframes toast-pop {
  0% {
    opacity: 0;
    transform: translateX(-50%) scale(0.6);
  }
  60% {
    opacity: 1;
    transform: translateX(-50%) scale(1.08);
  }
  80% {
    transform: translateX(-50%) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
}
</style>
